/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_YesterdayInputs */



/**
* | output |
* | --- |
* | "Yesterday" |
*
* @param {Agenda_YesterdayInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_yesterday = /** @type {((inputs?: Agenda_YesterdayInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_YesterdayInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Gisteren")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Hier")
	return /** @type {LocalizedString} */ ("Yesterday")
});